import React from "react";
import { useInView } from "../Hooks/useInView";
import styles from "./AboutTextBlock.module.css";

const AboutTextBlock: React.FC = () => {
  const [aboutRef, aboutInView] = useInView<HTMLDivElement>(0.4);
  const [mgmtRef, mgmtInView] = useInView<HTMLDivElement>(0.4);

  return (
    <section
      id="about"
      className={styles.introBlock}
      aria-label="Über uns – Textblock"
    >
      <div className={styles.introText}>
        <div className={styles.introHeader}>
          <span className={styles.vLabel} aria-hidden="true">
            Unternehmen
          </span>
          <h2 className={styles.introH2}>Dr. Fernando International GmbH</h2>
        </div>
      </div>

      <div
        ref={aboutRef}
        className={`${styles.introText} ${styles.animated} ${
          aboutInView ? styles.reveal : ""
        }`}
      >
        <p>
          Ihr starker Partner für internationale Projektentwicklung mit Substanz
          und Vision.
        </p>

        <p>
          Als inhabergeführtes Immobilienunternehmen mit Sitz in Berlin-Steglitz
          entwickeln wir bei der
          <strong> Dr. Fernando International GmbH </strong>
          seit 2004 anspruchsvolle Wohn- und Gewerbeimmobilien.
        </p>

        <p>
          Die <strong>Dr. Fernando International GmbH</strong> wurde mit dem
          Ziel gegründet, werthaltige Immobilienprojekte zu realisieren. Wir
          entwickeln maßgeschneiderte Lösungen für Wohn-, Gewerbe- und
          Mixed-Use-Immobilien und begleiten Bauvorhaben von der ersten Idee bis
          zur erfolgreichen Umsetzung. Unsere Spezialgebiete sind die
          Entwicklung von Wohnquartieren und betreutem Wohnen.
        </p>

        <p>
          Unser Anspruch dabei: Architektur von bleibendem Wert. Unsere Projekte
          verbinden höchste bauliche Qualität mit einer klaren Vision – für
          Lebensräume, die Bestand haben und Generationen verbinden.
        </p>

        <p>
          Mit unseren Kernkompetenzen – Investition, Projektentwicklung,
          bauliche Umsetzung und Bestandsverwaltung – schaffen wir nicht nur
          Immobilien, sondern nachhaltige Werte. Im Zentrum unseres Handelns
          stehen Verlässlichkeit, Partnerschaft, unternehmerische Verantwortung
          und fachliche Kompetenz.
        </p>

        <p>
          Was uns auszeichnet, ist die Leidenschaft für jedes Detail – von der
          ersten Idee bis zur letzten Bauphase. Diese Liebe zur Präzision spüren
          unsere Kunden, Investoren und späteren Nutzer weit über den Einzug
          hinaus.
        </p>
      </div>

      <div
        ref={mgmtRef}
        className={`${styles.introText} ${styles.animated} ${
          mgmtInView ? styles.reveal : ""
        }`}
      >
        <div className={styles.introHeader}>
          <span className={styles.vLabel} aria-hidden="true">
            Management
          </span>
          <h2 className={styles.introH2}>
            Führung mit Erfahrung, Weitblick und unternehmerischer Verantwortung
          </h2>
        </div>

        <p>
          Das Management der <strong>Dr. Fernando International GmbH</strong>{" "}
          steht für klare Entscheidungen, fundiertes Fachwissen und eine
          werteorientierte Unternehmensführung. Als inhabergeführtes Unternehmen
          verbinden wir strategischen Blick mit operativer Nähe – und
          stellen sicher, dass jedes Projekt mit höchstem Qualitätsanspruch
          umgesetzt wird.
        </p>

        <p>
          <strong>Dr. Fernando – Visionär, Unternehmer, Gestalter</strong>
          <br />
          <br />
        Unter der Leitung von Dr. Douglas Fernando, Gründer und Geschäftsführer, hat sich das Unternehmen seit 2004 zu einem stabilen Akteur in der nationalen und internationalen Projektentwicklung entwickelt. Seine Erfahrung in der Immobilienwirtschaft, kombiniert mit unternehmerischer Weitsicht und ausgeprägtem Gespür für gesellschaftliche Entwicklungen, prägt jedes Projekt von der Idee bis zur Realisierung. 
          <br />
          <br />
       Inklusion, Nachhaltigkeit, Beteiligung und Wirkung sind die Eckpfeiler – vom ersten Entwurf bis zur lebendigen Nachbarschaft. Dr. Fernando steht für Projekte, die möglichst viele Menschen erreichen und gleichzeitig nachhaltig wirtschaften.
        </p>

        <p>
          <strong>Führung mit Haltung</strong>
          <br />
          <br />
         Unsere Unternehmensführung ist geprägt von Integrität, Verantwortung und dem Anspruch, nicht nur wirtschaftlich tragfähige, sondern auch gesellschaftlich relevante Projekte zu realisieren. Entscheidungen werden bei uns nicht anonyme Prozesse, sondern persönliche Verpflichtung – getragen von Kompetenz, Erfahrung und einem starken Wertefundament.
        </p>

        <p>
          Vertrauen entsteht durch Klarheit. Führung entsteht durch
          Verantwortung. Das Management der{" "}
          <strong>Dr. Fernando International GmbH</strong> steht für beides –
          und für Immobilienprojekte, die Bestand haben.
        </p>
      </div>
    </section>
  );
};

export default AboutTextBlock;
